import { gql } from "@apollo/client";

const SUBSCRIBE_FACEBOOK_PAGES = gql`
  mutation SubscribeFacebookPages(
    $pageIds: [String!]!
    $accessTokens: [String!]!
  ) {
    subscribeFacebookPages(pageIds: $pageIds, accessTokens: $accessTokens) {
      success
      error
      result
    }
  }
`;

export default SUBSCRIBE_FACEBOOK_PAGES;
